import _find from 'lodash/find';
import './waiting-students.scss';
import registerStudentTemplate from './../register-student/register-student.html';
import template from './waiting-students.html';

class WaitingStudentsComponent {
  /** @ngInject */
  constructor(
    $rootScope, $log, $interval, $mdSidenav, $mdDialog, $mdToast,
    GroupService,
    StudentService,
    ClassRoomService,
    EmployeeService
  ) {
    this.$rootScope = $rootScope;
    this.$log = $log;
    this.$interval = $interval;
    this.$mdSidenav = $mdSidenav;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.GroupService = GroupService;
    this.StudentService = StudentService;
    this.ClassRoomService = ClassRoomService;
    this.EmployeeService = EmployeeService;

    this.currentClassRoom = {};
    this.waitingStudents = [];
    this.createdWaitingStudents = [];
  }

  $onInit() {
    this.StudentService.getWaitingStudents().then(result => {
      this.waitingStudents = result;
    });

    this.ClassRoomService.getCurrentClassRoom().then(result => {
      this.currentClassRoom = result;
    });

    this.EmployeeService.getCreatedWaitingStudents().then(result => {
      this.createdWaitingStudents = result;
    });

    this.waitingStudentsInterval = this.$interval(() => {
      this.loadWaitingStudents(0, false);
    }, 180000);

    this.createdWaitingStudentsInterval = this.$interval(() => {
      this.loadCreatedWaitingStudents(0, false);
    }, 180000);

    this.$rootScope.$on('component.dashboard.close-attendance', (target, attendance) => {
      if (Number(attendance.categoryOfDepartureId) === 2) {
        this.loadWaitingStudents(0, false);
        this.loadCreatedWaitingStudents(0, false);
      }
    });
  }

  $onChanges(changes) {
    if (changes.groups) {
      this.groups = {...this.groups};
    }

    if (changes.access) {
      this.access = {...this.access};
    }

    if (changes.classRooms) {
      this.classRooms = {...this.classRooms};
    }
  }

  $onDestroy() {
    this.$interval.cancel(this.waitingStudentsInterval);
    this.$interval.cancel(this.createdWaitingStudentsInterval);
  }

  toggleWaitingStudents() {
    this.$mdSidenav('waiting-students')
      .toggle();
  }

  loadWaitingStudents(groupId = 0, showLoaderSpinner = true) {
    let id = groupId;
    if (angular.isDefined(this.selectedWaitingGroupId) && this.selectedWaitingGroupId > 0) {
      id = this.selectedWaitingGroupId;
    }

    this.StudentService.getWaitingStudents({groupId: id, showLoaderSpinner}).then(result => {
      this.waitingStudents = result;
      this.onUpdate({students: this.waitingStudents});
    })
      .catch(() => {
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Nie udało się pobrać oczekujących uczniów')
            .position('bottom right')
            .hideDelay(3000)
        );
      });
  }

  loadCreatedWaitingStudents(groupId = 0, showLoaderSpinner = true) {
    let id = groupId;
    if (angular.isDefined(this.selectedCreatedWaitingGroupId) && this.selectedCreatedWaitingGroupId > 0) {
      id = this.selectedCreatedWaitingGroupId;
    }

    this.StudentService.getCreatedWaitingStudents({groupId: id, showLoaderSpinner}).then(result => {
      this.createdWaitingStudents = result;
    })
      .catch(() => {
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Nie udało się pobrać przekazanych uczniów')
            .position('bottom right')
            .hideDelay(3000)
        );
      });
  }

  registerStudents(ids, ev) {
    const students = [];
    ids.forEach(id => {
      students.push(_find(this.waitingStudents, item => item.id === id));
    });
    const copyStudents = [];
    angular.copy(students, copyStudents);
    copyStudents.forEach(student => {
      student.waitingStudentId = student.id;
      student.fullName = student.studentName;
      student.id = student.studentId;
      student.categoryOfDepartureId = null;
      student.endTime = null;
    });
    this.openRegisterStudentDialog(copyStudents, ev);
  }

  openRegisterStudentDialog(students, ev) {
    this.$mdDialog.show({
      bindToController: true,
      controllerAs: 'ctrl',
      controller: 'RegisterStudentController',
      locals: {
        students,
        currentClassRoom: this.currentClassRoom,
        access: this.access,
        classRooms: this.classRooms
      },
      template: registerStudentTemplate,
      disableParentScroll: true,
      clickOutsideToClose: true,
      targetEvent: ev
    })
      .then(() => {
        this.selectedStudentsIDs = [];
        this.loadWaitingStudents();
        this.$rootScope.$broadcast('component.waiting-students.register-student');
      });
  }

  registerSelected(ev) {
    if (this.selectedStudentsIDs.length > 0) {
      this.registerStudents(this.selectedStudentsIDs, ev);
    } else {
      this.$mdToast.show(
        this.$mdToast.simple()
          .textContent('Zaznacz uczniów do zarejestrowania')
          .position('bottom right')
          .hideDelay(3000)
      );
    }
  }

  removeSelected(ev) {
    if (this.selectedStudentsIDs.length > 0) {
      this.removeWaitingStudents(this.selectedStudentsIDs, ev);
    } else {
      this.$mdToast.show(
        this.$mdToast.simple()
          .textContent('Zaznacz uczniów do usunięcia')
          .position('bottom right')
          .hideDelay(3000)
      );
    }
  }

  removeWaitingStudents(ids, ev) {
    ev.stopPropagation();
    const confirm = this.$mdDialog.confirm()
      .title('Czy na pewno chcesz usunąć wpis?')
      .textContent('U nauczyciela przekazującego zniknie informacja o przekazaniu.')
      .ariaLabel('Usunięcie ucznia oczekującego')
      .targetEvent(ev)
      .ok('Usuń')
      .cancel('Zamknij');

    this.$mdDialog.show(confirm).then(() => {
      const waitingStudent = _find(this.waitingStudents, student => student.id === ids[0]);
      if (waitingStudent) {
        this.EmployeeService.deleteWaitingStudent(waitingStudent.receiverId, ids)
          .then(() => {
            this.loadWaitingStudents(0, true);
          })
          .catch(error => {
            this.$mdDialog.show(
              this.$mdDialog.extendError({
                locals: {error}
              })
            );
          });
      }
    });
  }

  selectedRowCallback(rowsIds) {
    this.selectedStudentsIDs = rowsIds;
  }
}

export const WaitingStudents = {
  bindings: {
    groups: '<',
    access: '<',
    classRooms: '<',
    onUpdate: '&'
  },
  template,
  controller: WaitingStudentsComponent
};
